import { render, staticRenderFns } from "./members-introduct.vue?vue&type=template&id=243816ce&scoped=true"
import script from "./members-introduct.vue?vue&type=script&lang=js"
export * from "./members-introduct.vue?vue&type=script&lang=js"
import style0 from "./members-introduct.vue?vue&type=style&index=0&id=243816ce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "243816ce",
  null
  
)

export default component.exports